<script>
export default {
  emits: ['update:modelValue'],
  props: {
    modelValue: Number,

    propTitle: String,
    propMinimum: Number,
    propMaximum: Number,
    propStep: {type: Number, default: 0.1},
    propDecimals: {type: Number, default: 1},
    propDecimalsMinimum: {type: Number, default: 1},
    propDecimalsMaximum: {type: Number, default: 1},
    propTooltipText: {type: String, default: null},
  },
  computed: {
    value: {
      get() {
        return this.modelValue
      },
      set(value) {
        this.$emit('update:modelValue', Number(value))
      }
    }
  },
  methods: {
    formatValue(value, decimals = 1) {
      // Ensures value is treated as a number before calling toFixed
      let valueNumber = Number(value);
      return isNaN(value) === false ? valueNumber.toFixed(decimals) : '';
    }
  }
}
</script>

<template>
  <label>
    <span class="me-1">{{ propTitle }}</span>
    <i class="bi bi-info-circle tooltip-slider-init cursor-pointer"
       data-bs-toggle="tooltip"
       data-bs-html="true"
       v-if="propTooltipText !== null"
       :data-bs-title='`<small>${propTooltipText}`'></i>
  </label>
  <div class="position-relative d-flex align-items-center">
    <!-- Slider -->
    <input
        type="range"
        v-model="value"
        :min="propMinimum"
        :max="propMaximum"
        :step="propStep"
        class="form-range flex-grow-1 me-2"
    />
    <!-- Current value displayed to the right -->
    <span class="badge bg-primary text-wrap">
        <span class="text-end fw-bold">{{ formatValue(value, propDecimals) }}</span>
      </span>
  </div>

  <!-- Min and Max Values Positioned Below -->
  <div class="d-flex justify-content-between mr-3 me-4">
    <span class="fw-bold slider_font_size text-secondary">{{ formatValue(propMinimum, propDecimalsMinimum) }}</span>
    <span class="me-3 fw-bold slider_font_size text-secondary">
      {{ formatValue(propMaximum, propDecimalsMaximum) }}
    </span>
  </div>
</template>